import { useViewPort } from "@website/hooks/viewport";
import { useCallback, useState } from "react";

export const usePopover = ({
  onClick,
  initialOpen = false
}: {
  onClick?: () => void;
  initialOpen?: boolean;
}) => {
  const [open, setOpen] = useState<boolean>(initialOpen);
  const { isDesktop } = useViewPort();
  const onClosePopover = useCallback(() => {
    setOpen(false);
    (process.env.NEXT_PUBLIC_BASE_PATHNAME?.includes("رزرو-هتل") ||
      (!process.env.NEXT_PUBLIC_BASE_PATHNAME?.includes("رزرو-هتل") &&
        isDesktop)) &&
      onClick?.();
  }, [isDesktop, onClick]);

  const onOpenPopover = useCallback(() => {
    setOpen(true);
  }, []);

  return {
    open,
    onOpenPopover,
    onClosePopover,
    popoverProperties: {
      animate: "bottom" as const,
      open,
      onClose: onClosePopover,
      position: "end" as const,
      gapHorizontal: "-24px",
      gapVertical: "-16px"
    }
  };
};
